import { Children as C, isValidElement as I } from "react";
import L from "../_virtual/index.es.js";
import { shallowEqual as h } from "../node_modules/fast-equals/dist/esm/index.es.js";
const P = [], T = {}, p = (t) => typeof t != "string" ? t == null ? void 0 : t.name : t, d = (t, E) => {
  const {
    children: n,
    filterMode: r,
    parent: a
  } = E || {}, f = C.map(t, (i) => {
    if (!I(i))
      throw new Error("Invalid child");
    const o = i;
    if (n && (typeof o.type == "string" || o.type.name !== p(n))) {
      if (r)
        return;
      throw new Error(`${p(a)} should only have ${p(n)} as children`);
    }
    return o;
  });
  return r ? f.filter((i) => !!i) : f;
}, l = (t, E) => {
  const n = t == null ? void 0 : t.map((a) => a == null ? void 0 : a[E]), r = new Set(n);
  if ((n == null ? void 0 : n.length) > (r == null ? void 0 : r.size)) throw new Error(`Invalid object array, need no duplicate of \`${E}\` prop`);
}, s = (t) => ({
  DIRECT_ACCEPTANCE: "DA",
  SPECIAL_EXEMPT: "SE",
  JUNIOR_EXEMPT: "JE",
  WILDCARD: "WC",
  ALTERNATE: "ALT",
  LUCKY_LOSER: "LL",
  QUALIFIER: "Q"
})[t], O = ({
  className: t,
  classNames: E,
  props: n,
  styles: r,
  sx: a,
  ...f
}, i, o) => [Object.fromEntries(Object.entries(i).map(([e, m]) => [e, (c) => ({
  className: L(o === e && t, (E == null ? void 0 : E[e]) && E[e], m == null ? void 0 : m({
    ...c,
    ...(r == null ? void 0 : r[e]) && {
      css: {
        ...c == null ? void 0 : c.css,
        ...o === e && a,
        ...r[e]
      }
    }
  })),
  ...n == null ? void 0 : n[e]
})])), f], R = ({
  classNames: t,
  styles: E,
  props: n,
  ...r
}, {
  classNames: a,
  styles: f,
  props: i,
  ...o
}) => h(r, o) && h(t, a) && h(E, f) && h(n, i);
export {
  R as compareBaseStyleProps,
  P as emptyArray,
  T as emptyObject,
  s as getEntryStatusAbbrv,
  d as getItemsProps,
  O as getStyleProps,
  l as validateObjectArrayNoDuplicate
};
//# sourceMappingURL=utils.es.js.map
